import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface LandRequirementCellProps {
  acres: number;
  exceedsSiteArea: boolean;
}

/**
 * Print-safe land-footprint cell. The warning is a named vector image so its
 * meaning survives PDF/UA export without relying on a fallback-font glyph.
 */
export function LandRequirementCell({
  acres,
  exceedsSiteArea,
}: LandRequirementCellProps): React.ReactElement {
  return (
    <span className="inline-flex items-center gap-1">
      <span>{acres} ac</span>
      {exceedsSiteArea ? (
        <AlertTriangle
          role="img"
          aria-label="Land requirement exceeds site area"
          data-pdf-land-overflow-mark="true"
          className="h-[0.9em] w-[0.9em] shrink-0"
          strokeWidth={1.75}
        />
      ) : null}
    </span>
  );
}
